import ProductCard from "../../components/products/ProductCard.jsx";
import Hero from "~/components/Hero.jsx";
import {Head, Link} from "@inertiajs/react";
import pageTitle from "~/utils/pageTitle.js";
import {Button} from "~/components/ui/button.jsx";
import Hero2 from "~/components/Hero2.jsx";
import {ChevronRight} from "lucide-react";
import Services from "@/components/home/Services/Services.jsx";
import Features from "@/components/home/Features/Features.jsx";
import {Heading} from "@/components/ui/heading.jsx";
import Hero3 from "@/components/Hero3.jsx";

export default function ({selections}) {

  return (
    <>
      <Head title={pageTitle('Главная')}/>
      <Hero3 />
      {/*<Hero/>*/}
      <div className="container mx-auto">
        <div className="space-y-8 px-2 xl:px-0">
          {selections.map(selection => {
            return (
              <div>
                <div className="flex justify-between items-center py-4 lx:py-8 px-2">
                  <Heading size="h2" as="h2" variant="highlight">{selection.title}</Heading>
                </div>
                <div className="grid gap-2 xl:gap-4 grid-cols-2 lg:grid-cols-4 xl:grid-cols-5 ">
                  {selection.products.map(product => {
                    return (
                      <ProductCard product={product} cover/>
                    )
                  })}
                </div>
                <div className="flex justify-center py-8">
                  <Button asChild variant="default" color={"pink"} size="xl">
                    <Link href={`/t/${selection.link}`}>
                      Показать все
                      <ChevronRight />
                    </Link>
                  </Button>
                </div>
              </div>

            )
          })}
        </div>
      </div>

      <Services />
      <Features />
    </>
  )
}